"use strict";

const Facades = () => {
    const init = () => {
        $(function () {
            var $facadesContainer = $('.js-facades');
            if ($facadesContainer.length > 0) {
                var $facadesTabs = $facadesContainer.find('.js-facades-tab');
                var $facadesSelect = $facadesContainer.find('.js-facades-select');

                $facadesTabs.on('click', function(){
                    $facadesTabs.removeClass('active');
                    $(this).addClass('active');
                    $facadesContainer.find('form [name="page"]').val(1);
                    $facadesContainer.find('form [name="storeys"]').val($(this).data('id'));
                    $facadesContainer.find('form .ajax-submit').trigger('click');
                });

                $facadesSelect.on('change', function(){
                    $facadesTabs.filter('[data-id="'+$(this).val()+'"]').trigger('click');
                });
            }
        });
    };

    return {
        init: init
    };
};

export default Facades;